var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M16.954 12.332l-3.817-1.639a.818.818 0 00-.954.235l-1.691 2.065a12.635 12.635 0 01-6.04-6.04l2.065-1.687a.816.816 0 00.235-.954L5.116.493A.824.824 0 004.179.02L.634.838a.818.818 0 00-.634.8 15.814 15.814 0 0015.816 15.814.818.818 0 00.8-.634l.818-3.545a.828.828 0 00-.48-.941z","fill":"currentColor","key":1})]);
}

Phone.defaultProps = {"viewBox":"0 0 17.452 17.452"};

module.exports = Phone;

Phone.default = Phone;
